module.exports = __webpack_public_path__ + "img/usp_icon3.129d542b.svg";